import React, { Component } from 'react';

import css from './Gender.module.scss';
import InclusivePronounSelection from '../../../components/InclusivePronounSelection/index.tsx';

export const WIDGET_NAME = 'set_user_gender';

class GenderWidget extends Component {
  state = {
    gender: ''
  };

  componentDidUpdate(prevProps, prevState) {
    const { shouldEnable, widget, changeAnswerValue } = this.props;
    if (prevState.gender !== this.state.gender) {
      shouldEnable(widget, true);
      changeAnswerValue(widget, this.state.gender);
    }
  }

  handleGenderChange = value => {
    this.setState({ gender: value });
  };

  errorChecking = () => {
    const { gender } = this.state;

    this.props.analytics.trackEvent('Registration Pronoun Submitted', {
      eventProps: {
        pronouns: [gender]
      }
    });
    return gender;
  };

  render = () => (
    <>
      <p className={css.genderSelectLabel}>How should we refer to you?</p>
      <InclusivePronounSelection
        {...this.props}
        embedded={true}
        options={
          this.props.toggles.preferNotToSayOptionEnabled
            ? [
                {
                  label: 'He/Him',
                  value: 'male'
                },
                {
                  label: 'She/Her',
                  value: 'female'
                },
                {
                  label: 'They/Them',
                  value: 'other'
                },
                {
                  label: 'Prefer not to say',
                  value: 'other'
                }
              ]
            : [
                {
                  label: 'he/him',
                  value: 'male'
                },
                {
                  label: 'she/her',
                  value: 'female'
                },
                {
                  label: 'they/them',
                  value: 'other'
                }
              ]
        }
        selected={this.state.gender}
        onChange={this.handleGenderChange}
      />
    </>
  );
}

export default GenderWidget;
